import type { SVGAttributes } from "react";

type HexColor = `#${string}` & { length: 4 | 7 };
type CssVar = `var(--${string})`;
export type IconHexColor = HexColor | CssVar; /* TODO: Rename this guy */

export interface BaseIconProps extends SVGAttributes<SVGSVGElement> {
    size?: number | string;
    customColor?: IconHexColor;
}

export interface DirectionalIconProps extends BaseIconProps {
    direction?: "up" | "down" | "left" | "right";
}

export type VariantStyles = {
    primary: string;
    secondary?: string;
    disabled?: string;
    error?: string;
};

type StyleSystem = {
    [Component: string]: {
        base: VariantStyles;
        [OtherStates: string]: VariantStyles;
    };
};

export type SizeVariants = {
    sm: string;
    md: string;
    lg: string;
};

export const tailwindSizeVariants: SizeVariants = {
    sm: "w-1/2",
    md: "w-3/4",
    lg: "w-full",
} as const;

export const tailwindStyleVariants: StyleSystem = {
    dropdown: {
        base: {
            primary:
                "border-neutral-400 text-neutral-800 focus:border-primary-400",
        },
        menu: {
            primary: "border-neutral-100",
        },
        hover: {
            primary:
                "border-neutral-100 hover:bg-neutral-100 focus:outline-hidden",
        },
    },
    button: {
        base: {
            primary:
                "text-white bg-primary-700 tw-border border-primary-700 hover:bg-primary-600 active:bg-blue-800 disabled:bg-blue-300 disabled:cursor-not-allowed disabled:border-blue-300 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-700",
            secondary:
                "text-gray-500 tw-bg-white px-5 border-2 border-gray-500 hover:bg-gray-200 active:bg-gray-300 active:border-gray-400 disabled:bg-gray-100 disabled:tw-border disabled:border-gray-300 disabled:text-gray-300 disabled:cursor-not-allowed focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600",
        },
    },
} as const;
